<template>
  <div class="priceContent">
    <!-- 轮播图 -->
    <div class="backimg">
      <img
        src="../../assets/img/price/banner.png"
        alt=""
        style="width:100%;height: 100%;object-fit:cover;vertical-align:middle;"
      />
      <div class="betweencenter">
        <div class="real">
          <div class="tis bigcolor">{{$t('price.title')}}</div>
          <div
            class="tixt"
            style="font-size:30px;color:#ccc;"
          >
            Connect at the touch
          </div>
        </div>
      </div>
    </div>
    <div class="priceContainer">
      <div
        class="creates"
        :class="this.$i18n.locale=='en'?'creatclo':''"
      >
        <div
          class="titles jtgreen"
          v-if="startStatus"
        >{{$t('price.header')}}</div>
        <div
          class="imgs"
          v-if="startStatus"
        >
          <img
            src="../../assets/img/price/start.png"
            alt=""
          />
          <div class="btns">
            <div
              class="elbutton"
              @click="createTap"
            >
              {{ btnobj.btnstart }}
            </div>
          </div>
          <img
            src="../../assets/img/price/end.png"
            alt=""
          />
          <div class="btns">
            <div
              class="elbutton"
              @click="createEnd"
            >
              {{ btnobj.btnend }}
            </div>
          </div>
          <!-- 基础配置 -->
          <div class="heads">
            <div
              class="fontw"
              :class="tapflag ? 'active' : 'one'"
              @click="tapbasis"
            >
              {{$t('price.taptitle')}}
            </div>
            &nbsp;
            <div style="height:20px;border-right:2px solid #1d5a33;line-height:20px;"></div>
            &nbsp;
            <div
              class="fontw"
              :class="tapflags ? 'actives' : 'two'"
              @click="taplines"
            >
              {{$t('price.texttitle')}}
            </div>
          </div>
          <div
            class="basis"
            v-if="tapflag"
          >
            <div class="dis">
              <span class="wid">{{$t('price.band')}}</span>
              <el-radio-group
                v-model="range"
                @change="bandChange"
              >
                <el-radio-button
                  v-for="item in $t('price.bandrange')"
                  :key="item.id"
                  :label="item.id"
                >
                  <p>{{ item.name }}</p>
                  <p>{{ item.names }}</p>
                </el-radio-button>
              </el-radio-group>
            </div>
            <div class="dis">
              <span class="wid">{{$t('price.selectband')}}</span>
              <el-select
                v-model="band"
                :placeholder="$t('checkvalid.select')"
                :disabled="bandStatus"
                @change="bandSelect"
              >
                <el-option
                  v-for="(item, it) in optiontime"
                  :key="it"
                  :label="item + 'M'"
                  :value="item"
                >
                </el-option>
              </el-select>
            </div>
          </div>
          <div
            class="basis"
            v-else
            style="width:350px;margin-bottom:30px;"
          >
            <el-form
              :label-width="this.$i18n.locale=='en'?'130px':'82px'"
              :model="packForm"
              ref="packForm"
              :rules="packrules"
              v-show="pack"
            >
              <el-form-item
                :label="$t('price.packnum')"
                prop="packnum"
                class="left"
              >
                <el-input
                  v-model="packForm.packnum"
                  class="inputsty"
                  :placeholder="$t('checkvalid.pack')"
                ></el-input>
              </el-form-item>
            </el-form>
            <div v-show="!pack">
              <div class="dis">
                <span
                  class="wid"
                  style="width:150px;text-align:center;"
                >{{$t('price.packtext')}}</span>
                <span class="inline">{{packtext}}</span>
              </div>

              <div class="dis">
                <span
                  class="wid"
                  style="width:150px;text-align:center;"
                >{{$t('price.loss')}}</span>
                <span class="inline">{{loss}}</span>
              </div>
              <div class="dis">
                <span
                  class="wid"
                  style="width:150px;text-align:center;"
                >
                  <div>{{$t('price.overtime')}}</div>
                </span>
                <span class="inline">{{overtime}}</span>
              </div>

            </div>

          </div>
          <div
            class="btns"
            style="margin-top:0;"
            v-if="tapflag"
          >
            <div class="headerTitle">
              <el-radio-group
                v-model="radio1"
                fill="#1d5a33"
              >
                <el-radio-button
                  :label="$t('price.radio')"
                  @click.native.prevent="otherneed"
                ></el-radio-button>
                <el-radio-button
                  :label="$t('price.radios')"
                  @click.native.prevent="submit"
                ></el-radio-button>
              </el-radio-group>
            </div>
          </div>
          <div
            style="width:370px;text-align:center;height:40px;"
            :class="this.pack?'hes':'low'"
            v-else
          >
            <div
              class="headerTitle"
              v-show="pack"
            >
              <el-button
                type="success"
                style="width:180px;border-radius:10px;margin-left:85px;"
                @click="tapclick"
              >{{$t('price.carry')}}</el-button>
            </div>
            <div
              class="headerTitle"
              v-show="!pack"
            >
              <el-button
                type="success"
                style="width:180px;border-radius:10px;"
                @click="tapclicks"
              >{{$t('price.reset')}}</el-button>
            </div>
          </div>
        </div>
        <!-- 提交后的价格 -->
        <div
          class="imgs"
          v-else
        >
          <p class="jtgreen hfont details">{{$t('price.detail')}}</p>
          <ul>
            <!-- 起点 -->
            <li>
              <div class="tr">{{$t('price.startconfig')}}</div>
              <p
                class="pc"
                v-show="this.mapData.cloud1.length"
              >
                <span>{{$t('price.cloudtype')}}</span>
                <span>{{ mapData.cloud1 }}</span>
              </p>
              <p class="pc">
                <span>{{$t('price.country')}}</span>
                <span>{{ mapData.country1 }}</span>
              </p>
              <p class="pc">
                <span>{{$t('price.area')}}</span>
                <span>{{ mapData.area1 }}</span>
              </p>
              <p class="pc">
                <span>{{$t('price.data')}}</span>
                <span>{{ mapData.data1.replace(/\"/g, "") }}</span>
              </p>
            </li>
            <!-- 终点 -->
            <li>
              <div class="tr">{{$t('price.endconfig')}}</div>
              <p
                class="pc"
                v-show="this.mapData.cloud2.length"
              >
                <span>{{$t('price.cloudtype')}}</span>
                <span>{{ mapData.cloud2 }}</span>
              </p>
              <p class="pc">
                <span>{{$t('price.country')}}</span>
                <span>{{ mapData.country2 }}</span>
              </p>
              <p class="pc">
                <span>{{$t('price.area')}}</span>
                <span>{{ mapData.area2 }}</span>
              </p>
              <p class="pc">
                <span>{{$t('price.data')}}</span>
                <span>{{ mapData.data2.replace(/\"/g, "") }}</span>
              </p>
            </li>
            <!-- 基础配置 -->
            <li>
              <div class="tr">{{$t('price.basisconfig')}}</div>
              <p class="pc">
                <span>{{$t('price.bandline')}}</span>
                <span>{{ line }} Mbps</span>
              </p>
            </li>
            <li style="border:none;">
              <div class="tr just">
                <span style="font-size:18px;display:block;">{{$t('price.monthmoney')}}</span>
                <span
                  style="color:red;font-size:28px;"
                  v-if="discountmoney!=money"
                >{{$i18n.locale=='en'?util.toPrices(parseInt(discountmoney/this.rate)): util.toPrice(Number(discountmoney)) }} {{$i18n.locale=='en'?'$':'¥'}} </span>
                &nbsp;&nbsp;
                <!-- $i18n.locale=='en'?util.toPrices(parseInt(discountmoney/7.109400000000001)): -->
                <span
                  v-if="money>0"
                  class="basisfont"
                  :class="discountmoney!=money?'lineth':'colorsred'"
                >{{ $i18n.locale=='en'?util.toPrices(parseInt(money/this.rate)):util.toPrice(Number(money)) }} {{$i18n.locale=='en'?'$':'¥'}} </span>
                <span
                  style="color:red;"
                  v-else
                >{{$t('price.none')}}</span>
              </div>
              <p style="text-align:left;line-height:2;font-size:16px;">
                {{$t('price.moneydetail')}}
              </p>

              <!-- DC类型 -->
              <p class="pcs just">
                <span>{{$t('price.linemoney')}}</span>
                <span
                  v-show="$i18n.locale=='zh'"
                  v-if="discountlinemoney>0"
                  style="color: #248f47;font-size:18px;margin-right:5px;"
                >{{ $i18n.locale=='en'?util.toPrices(parseInt(discountlinemoney/this.rate)):util.toPrice(Number(discountlinemoney)) }} {{$t('price.unit')}}</span>
                <span
                  v-show="$i18n.locale=='zh'"
                  v-if="linemoney>0"
                  :class="discountlinemoney>0?'lineth':''"
                >{{$i18n.locale=='en'?util.toPrices(parseInt(linemoney/this.rate)):util.toPrice(Number(linemoney)) }} {{$t('price.unit')}}</span>
                <span v-else>{{$t('price.none')}}</span>
              </p>
              <p v-show="$i18n.locale=='en'">
                <span
                  v-if="discountlinemoney>0"
                  style="color: #248f47;font-size:18px;margin-right:5px;"
                >{{ $i18n.locale=='en'?util.toPrices(parseInt(discountlinemoney/this.rate)):util.toPrice(Number(discountlinemoney)) }} {{$t('price.unit')}}</span>
                <span
                  v-if="linemoney>0"
                  :class="discountlinemoney>0?'lineth':''"
                >{{$i18n.locale=='en'?util.toPrices(parseInt(linemoney/this.rate)):util.toPrice(Number(linemoney)) }} {{$t('price.unit')}}</span>
                <span v-else>{{$t('price.none')}}</span>
              </p>
              <!-- 云端 -->
              <p
                class="pcs just"
                v-show="this.mapData.cloud1 || this.mapData.cloud2"
              >
                <span>{{$t('price.cloudmoneyall')}}</span>
                <span
                  v-show="$i18n.locale=='zh'"
                  v-if="discountcloudmoney>0"
                  style="color: #248f47;margin-right:5px;font-size:18px;"
                >{{ $i18n.locale=='en'?util.toPrices(parseInt(discountcloudmoney/this.rate)):util.toPrice(Number(discountcloudmoney)) }} {{$t('price.unit')}}</span>
                <span
                  v-show="$i18n.locale=='zh'"
                  v-if="cloundmoney>0"
                  :class="discountcloudmoney>0?'lineth':''"
                >{{ $i18n.locale=='en'?util.toPrices(parseInt(cloundmoney/this.rate)):util.toPrice(Number(cloundmoney)) }} {{$t('price.unit')}}</span>
                <span v-else>{{$t('price.nonecloud')}}</span>
              </p>
              <p v-show="$i18n.locale=='en'&&cloundmoney>0">
                <span
                  v-if="discountcloudmoney>0"
                  style="color: #248f47;margin-right:5px;font-size:18px;"
                >{{ $i18n.locale=='en'?util.toPrices(parseInt(discountcloudmoney/this.rate)):util.toPrice(Number(discountcloudmoney)) }} {{$t('price.unit')}}</span>
                <span
                  v-if="cloundmoney>0"
                  :class="discountcloudmoney>0?'lineth':''"
                >{{$i18n.locale=='en'?util.toPrices(parseInt(cloundmoney/this.rate)): util.toPrice(Number(cloundmoney)) }} {{$t('price.unit')}}</span>
                <span v-else>{{$t('price.nonecloud')}}</span>
              </p>
              <p class="pcs just">
                <span>{{$t('price.nonecurmoney')}}</span>
                <span
                  v-show="$i18n.locale=='zh'"
                  v-if="discountonemoney>0"
                  style="color: #248f47;font-size:18px;margin-right:5px;"
                >{{$i18n.locale=='en'?util.toPrices(parseInt(discountonemoney/this.rate)):util.toPrice(Number(discountonemoney)) }} {{$t('price.ele')}}</span>
                <span
                  v-show="$i18n.locale=='zh'"
                  v-if="onemoney>0"
                  :class="discountonemoney>0?'lineth':''"
                >{{ $i18n.locale=='en'?util.toPrices(parseInt(onemoney/this.rate)):util.toPrice(Number(onemoney)) }} {{$t('price.ele')}}</span>
                <span v-else>{{$t('price.none')}}</span>
              </p>
              <p v-show="$i18n.locale=='en'">
                <span
                  v-if="discountonemoney>0"
                  style="color: #248f47;font-size:18px;margin-right:5px;"
                >{{$i18n.locale=='en'?util.toPrices(parseInt(discountonemoney/this.rate)):util.toPrice(Number(discountonemoney)) }} {{$t('price.ele')}}</span>
                <span
                  v-if="onemoney>0"
                  :class="discountonemoney>0?'lineth':''"
                >{{$i18n.locale=='en'?util.toPrices(parseInt(onemoney/this.rate)): util.toPrice(Number(onemoney)) }} {{$t('price.ele')}}</span>
                <span v-else>{{$t('price.none')}}</span>
              </p>
              <br />
              <p class="pc">{{$t('price.tel')}}</p>
            </li>
          </ul>
          <div
            class="btns"
            style="margin:0;"
          >
            <div class="headerTitle">
              <el-radio-group
                v-model="radio2"
                fill="#1d5a33"
              >
                <el-radio-button
                  :label="$t('price.relocation')"
                  @click.native.prevent="relocation"
                ></el-radio-button>
                <el-radio-button
                  :label="$t('price.aftersale')"
                  @click.native.prevent="aftersale"
                ></el-radio-button>
              </el-radio-group>
            </div>
          </div>
        </div>
      </div>
      <div class="maps">
        <!-- <map-world
          :newdata="newdata"
          ref="initEcharts"
          :startSt="startSt"
          :first="first"
        ></map-world> -->
        <map-china
          :newdata="newdata"
          ref="initEcharts"
          :startSt="startSt"
          :first="first"
        ></map-china>
      </div>
      <price-create
        :diglog="diglog"
        @func="show"
        :packtext="packtext"
        :optioncloud="optioncloud"
      ></price-create>
      <price-end
        :diglogEnd="diglogEnd"
        :packtext="packtext"
        @end="endname"
        :optioncloud="optioncloud"
      ></price-end>
    </div>
    <!-- 提交售后 -->
    <el-dialog
      :title="dialogText"
      :visible.sync="centerDialogVisible"
      width="38%"
      center
    >
      <div class="dialogs">
        <img
          src="../../assets/img/price/right.png"
          alt=""
        />
        <div class="text textfont">
          {{$t('pricedialog.text')}}
        </div>
        <div class="tit textfont">{{$t('pricedialog.config')}}</div>
        <ul>
          <li>
            <span>{{$t('pricedialog.startdeploy')}}</span>
            <span>{{ startdeploy }}</span>
          </li>
          <li>
            <span>{{$t('pricedialog.enddeploy')}}</span>
            <span>{{ enddeploy }}</span>
          </li>
          <li>
            <span>{{$t('pricedialog.basisdeploy')}}</span>
            <span>{{ basisdeploy }}</span>
          </li>
          <li>
            <span>{{$t('pricedialog.refermoney')}}</span>
            <span>{{$i18n.locale=='en'?'$':'¥'}} {{$i18n.locale=='en'?util.toPrices(parseInt(refermoney/this.rate)): refermoney }}{{$t('price.month')}}</span>
          </li>
        </ul>
      </div>
    </el-dialog>
    <required></required>
  </div>
</template>
<script>
import priceCreate from "./priceCreate";
import priceEnd from "./priceEnd";
import mapWorld from "./mapWorld";
import required from "./required";
import mapChina from "./mapChina";
export default {
  components: {
    priceCreate,
    priceEnd,
    mapWorld,
    required,
    mapChina
  },
  data() {
    var packvalid = (rule, value, callback) => {
      var rest = /\D|^0/g;
      if (rest.test(value)) {
        return callback(new Error(this.$t("checkvalid.smallthan")));
      } else if (Number(value) > 10000) {
        return callback(new Error(this.$t("checkvalid.smallthan")));
      } else if (!value) {
        return callback(new Error(this.$t("checkvalid.packnum")));
      } else {
        callback();
      }
    };
    return {
      startStatus: true,
      bandStatus: true,
      btnobj: {
        btnstart: this.$t("pricedialog.dialogTextStart"),
        btnend: this.$t("pricedialog.dialogTextEnd")
      },
      radio1: this.$t("price.radios"),
      radio2: this.$t("price.aftersale"),
      // 带宽范围
      bandrange: [
        {
          id: "1",
          name: "小于",
          names: "100M",
          namesnum1: "",
          namesnum2: "100"
        },
        {
          id: "2",
          name: "100M",
          names: "-500M",
          namesnum1: "100",
          namesnum2: "500"
        },
        {
          id: "3",
          name: "500M",
          names: "-1G",
          namesnum1: "500",
          namesnum2: "1000"
        },
        {
          id: "4",
          name: "大于",
          names: "1G",
          namesnum1: "1000",
          namesnum2: ""
        }
      ],
      // 基础配置
      line: "0",
      typeport: "",
      // times: "",//时长
      money: "152.00￥",
      port: "",
      range: "", //带宽范围
      band: "", //带宽
      linemoney: "", //线路费用
      onemoney: "", //一次性费用
      cloundmoney: "", //云专线费用
      // 端口类型
      options: [
        {
          value: "1G单模光口",
          label: "1G单模光口"
        },
        {
          value: "10G单模光口",
          label: "10G单模光口"
        }
      ],
      // 带宽
      optiontime: [],
      // 配置详情
      centerDialogVisible: false,
      // 弹窗-起点
      diglog: {
        dialogStatus: true,
        dialogText: "",
        dataStatus: false,
        cloudStatus: false,
        centerDialogVisible: false
      },
      // 弹窗-终点
      diglogEnd: {
        dialogStatus: true,
        dialogText: "",
        dataStatus: false,
        cloudStatus: false,
        centerDialogVisible: false
      },
      // 起点
      names: "",
      type: "",
      city: "",
      nation: "",
      citys: "",
      nations: "",
      priceData: "",
      namesdata: "",
      typedata: "",
      citydata: "",
      nationdata: "",
      moneyArray: [],
      // 提交售后
      dialogText: this.$t("pricedialog.dialogtext"),
      centerDialogVisible: false,
      startdeploy: "",
      enddeploy: "",
      basisdeploy: "",
      refermoney: "",
      optioncloud: [],
      popid: "",
      popDataid: "",
      startBandwidth: "",
      endBandwidth: "",
      // 配置详情
      mapData: {
        cloud1: "",
        area1: "",
        country1: "",
        data1: "",
        cloud2: "",
        area2: "",
        country2: "",
        data2: ""
      },
      data: this.$t("mapworld.data"),
      newdata: [],
      newdatafirst: [],
      newdataend: [],
      startSt: 2,
      first: 2,
      startSts: true,
      start_cloud: "",
      end_cloud: "",
      tapflag: true,
      tapflags: false,
      pack: true,
      packForm: {
        packnum: ""
      },
      packrules: {
        packnum: [{ validator: packvalid, trigger: "blur" }]
      },
      packtext: "", //包数
      overtime: this.$t("checkvalid.loss"),
      loss: this.$t("checkvalid.loss"),
      citystartid: "",
      cityendid: "",
      looktime: "",
      avg: "",
      // 折后价
      discountmoney: "",
      discountlinemoney: "",
      discountonemoney: "",
      discountcloudmoney: "",
      discount_start: "",
      discount_end: "",
      newdiscount: "",
      newonediscount: "",
      newclouddiscount: ""
    };
  },
  watch: {
    btnobj: {
      handler(newVal, oldVal) {
        console.log(newVal);
        if (
          newVal.btnstart != this.$t("pricedialog.dialogTextStart") &&
          newVal.btnend != this.$t("pricedialog.dialogTextEnd")
        ) {
          this.bandStatus = false;
        } else {
          this.bandStatus = true;
        }
      },
      deep: true
    }
  },
  mounted() {
    this.getcloud();
    this.getbandwidth();
    this.getrate();
  },
  methods: {
    otherneed() {
      this.$store.state.otherDialogStatus = true;
      this.radio1 = this.$t("price.radio");
    },
    // 执行延时
    tapclick() {
      this.overtime = this.$t("checkvalid.loss");
      this.loss = this.$t("checkvalid.loss");
      if (this.names.length <= 0) {
        this.$message({
          message: this.$t("checkvalid.start"),
          type: "warning",
          duration: 1000
        });
        return;
      } else if (this.namesdata.length <= 0) {
        this.$message({
          message: this.$t("checkvalid.end"),
          type: "warning",
          duration: 1000
        });
        return;
      }
      this.$refs.packForm.validate(valid => {
        if (valid) {
          const data = {
            token: this.$store.state.token,
            start_city_id: this.citystartid,
            end_city_id: this.cityendid
          };
          this.$http
            .post("/price/get_delay", data)
            .then(res => {
              if (res.status == 200) {
                if (res.data.status == 0) {
                  this.pack = false;
                  this.packtext = this.packForm.packnum;
                  console.log(res.data.data);
                  this.avg = res.data.data.avg;
                  console.log(typeof this.avg);
                  console.log(typeof this.packtext);
                  this.looktime = this.avg * Number(this.packtext);
                  console.log(this.looktime);
                  var _this = this;
                  setTimeout(() => {
                    _this.overtime = _this.avg + "ms";
                    // _this.overtime = res.data.data.min+'/'+_this.avg+'/'+res.data.data.max+'ms';
                    console.log(_this.overtime);
                    _this.loss = "0.00%";
                  }, _this.looktime);
                } else {
                  this.$message({
                    message: res.data.error,
                    type: "warning",
                    duration: 1500
                  });
                  return;
                }
              }
            })
            .catch(err => {
              console.log(err);
            });
        } else {
          console.log("error submit!!");
          return;
        }
      });
    },
    // 重置
    tapclicks() {
      this.pack = true;
      this.packForm.packnum = "";
      this.overtime = this.$t("checkvalid.loss");
      this.loss = this.$t("checkvalid.loss");
    },
    // 重新配置
    relocation() {
      this.startStatus = true;
      this.btnobj.btnstart = this.$t("pricedialog.dialogTextStart");
      this.btnobj.btnend = this.$t("pricedialog.dialogTextEnd");
      this.startSt = 4;
      console.log(this.startSt);
      this.first = 4;
      console.log(this.first);
      this.range = "";
      this.band = "";
      this.port = "";
      this.names = "";
      this.type = "";
      this.nation = "";
      this.city = "";
      this.namesdata = "";
      this.typedata = "";
      this.nationdata = "";
      this.citydata = "";
    },
    // 带宽
    bandChange(val) {
      console.log(val);
      this.band = "";
      this.bandrange.map(item => {
        if (val == item.id) {
          this.startBandwidth = item.namesnum1;
          this.endBandwidth = item.namesnum2;
        }
      });
      this.getbandwidth();
    },
    bandSelect(val) {},
    // 提交售后
    aftersale() {
      this.centerDialogVisible = true;
      this.startdeploy =
        this.mapData.country1 +
        "-" +
        this.mapData.area1 +
        "-" +
        this.mapData.data1.replace(/\"/g, "");
      this.enddeploy =
        this.mapData.country2 +
        "-" +
        this.mapData.area2 +
        "-" +
        this.mapData.data2.replace(/\"/g, "");
      this.basisdeploy = this.line + "Mbps";
      this.refermoney = this.discountmoney;
      const data = {
        token: this.$store.state.token,
        start_pop_id: this.popid,
        end_pop_id: this.popDataid,
        bandwidth: this.band,
        port_type: this.typeport
      };
      this.$http
        .post("/price/submit_option_demand", data)
        .then(res => {
          if (res.status == 200) {
            if (res.data.status == 0) {
              console.log(res.data.data);
            }
          }
        })
        .catch(err => {
          console.log(err);
        });
    },
    // 配置详情信息
    show(names, nation, city, id, cityid, type) {
      this.btnobj.btnstart =
        JSON.parse(JSON.stringify(JSON.parse(names))) +
        "(" +
        this.$t("personal.edit") +
        ")";
      console.log(this.btnobj.btnstart);
      this.names = JSON.parse(JSON.stringify(names));
      if (type) {
        this.optioncloud.map(item => {
          if (type == item.id) {
            this.type =
              this.$i18n.locale == "en"
                ? JSON.parse(JSON.stringify(item.en_name))
                : JSON.parse(JSON.stringify(item.name));
          }
        });
      } else {
        this.type = "";
      }
      this.nation = JSON.parse(JSON.stringify(nation));
      console.log(this.nation);
      this.city = JSON.parse(JSON.stringify(city));
      this.popid = id;
      this.citystartid = cityid;
      console.log(this.citystartid);
    },
    // 配置详情信息
    endname(names, nation, city, id, cityid, type) {
      this.btnobj.btnend =
        JSON.parse(JSON.stringify(JSON.parse(names))) +
        "(" +
        this.$t("personal.edit") +
        ")";
      this.namesdata = JSON.parse(JSON.stringify(names));
      if (type) {
        this.optioncloud.map(item => {
          if (type == item.id) {
            this.typedata =
              this.$i18n.locale == "en"
                ? JSON.parse(JSON.stringify(item.en_name))
                : JSON.parse(JSON.stringify(item.name));
          }
        });
      } else {
        this.typedata = "";
      }
      this.nationdata = JSON.parse(JSON.stringify(nation));
      this.citydata = JSON.parse(JSON.stringify(city));
      this.popDataid = id;
      this.cityendid = cityid;
      console.log(this.cityendid);
    },
    // 创建起点
    createTap() {
      this.diglog.dialogText = this.$t("pricedialog.dialogTextStart");
      this.diglog.centerDialogVisible = true;
      this.diglog.dialogStatus = true;
      this.diglog.cloudStatus = false;
      this.diglog.dataStatus = false;
      if (this.newdatafirst.length > 0) {
        this.first = 16;
      } else if (this.newdatafirst.length > 1) {
        this.first = 20;
      } else {
        this.first = 2;
      }
    },
    // 创建终点
    createEnd() {
      if (this.btnobj.btnstart == this.$t("pricedialog.dialogTextStart")) {
        this.$message({
          message: this.$t("checkvalid.start"),
          type: "warning",
          duration: 1500
        });
        return;
      }
      this.diglogEnd.dialogText = this.$t("pricedialog.dialogTextEnd");
      this.diglogEnd.centerDialogVisible = true;
      this.diglogEnd.dialogStatus = true;
      this.diglogEnd.cloudStatus = false;
      this.diglogEnd.dataStatus = false;
      console.log(this.newdata);
      if (this.newdataend.length > 0) {
        this.startSt = 16;
      } else if (this.newdataend.length > 1) {
        this.startSt = 20;
      } else {
        this.startSt = 2;
      }
    },
    // 价格
    submit() {
      this.radio1 = this.$t("price.radios");
      if (this.names.length <= 0) {
        this.$message({
          message: this.$t("checkvalid.start"),
          type: "warning",
          duration: 1000
        });
        return;
      } else if (this.namesdata.length <= 0) {
        this.$message({
          message: this.$t("checkvalid.end"),
          type: "warning",
          duration: 1000
        });
        return;
      } else if (this.band.length <= 0) {
        this.$message({
          message: this.$t("checkvalid.band"),
          type: "warning",
          duration: 1000
        });
        return;
      }
      this.startStatus = false;
      // 基础配置
      this.line = this.band;
      this.typeport = this.port;
      // 起点
      if (this.type) {
        this.mapData.cloud1 = this.type;
        this.mapData.country1 = this.nation;
        this.mapData.area1 = this.city;
        this.mapData.data1 = this.names;
      } else {
        this.mapData.cloud1 = "";
        this.mapData.country1 = this.nation;
        this.mapData.area1 = this.city;
        this.mapData.data1 = this.names;
      }
      // 终点
      if (this.typedata) {
        this.mapData.cloud2 = this.typedata;
        this.mapData.country2 = this.nationdata;
        this.mapData.area2 = this.citydata;
        this.mapData.data2 = this.namesdata;
      } else {
        this.mapData.cloud2 = "";
        this.mapData.country2 = this.nationdata;
        this.mapData.area2 = this.citydata;
        this.mapData.data2 = this.namesdata;
      }
      // 下面是价格-调接口
      const data = {
        token: this.$store.state.token,
        start_pop_id: this.popid,
        end_pop_id: this.popDataid,
        bandwidth: this.band
      };
      this.$http
        .post("/price/get_offer", data)
        .then(res => {
          if (res.status == 200) {
            if (res.data.status == 0) {
              console.log(res.data.data);
              // 没有云端口
              this.linemoney = res.data.data.base.month_fee
                ? res.data.data.base.month_fee
                : "";
              this.onemoney = res.data.data.base.once_fee
                ? res.data.data.base.once_fee
                : "";

              // 公有云
              this.start_cloud = res.data.data.start_cloud
                ? Number(res.data.data.start_cloud.month_fee)
                : 0;
              this.end_cloud = res.data.data.end_cloud
                ? Number(res.data.data.end_cloud.month_fee)
                : 0;
              this.cloundmoney = this.start_cloud + this.end_cloud;
              this.money = Number(this.linemoney) + this.cloundmoney;
              // 折扣价
              // 线路费用
              this.discountlinemoney = res.data.data.base.discount_month_fee
                ? Number(res.data.data.base.discount_month_fee)
                : 0;
              // 一次性费用
              this.discountonemoney = res.data.data.base.discount_month_fee
                ? Number(res.data.data.base.discount_once_fee)
                : 0;
              // 云端口费用
              this.discount_start = res.data.data.start_cloud
                ? Number(res.data.data.start_cloud.discount_month_fee)
                : 0;
              this.discount_end = res.data.data.end_cloud
                ? Number(res.data.data.end_cloud.discount_month_fee)
                : 0;
              this.discountcloudmoney = this.discount_start + this.discount_end;
              if (this.discountlinemoney > 0) {
                this.newdiscount = this.discountlinemoney;
              } else {
                this.newdiscount = this.linemoney;
              }
              if (this.discountonemoney > 0) {
                this.newonediscount = this.discountonemoney;
              } else {
                this.newonediscount = this.onemoney;
              }
              if (this.discountcloudmoney > 0) {
                this.newclouddiscount = this.discountcloudmoney;
              } else {
                this.newclouddiscount = this.cloundmoney;
              }
              this.discountmoney =
                Number(this.newdiscount) + Number(this.newclouddiscount);
              console.log(typeof this.discountmoney);
            }
          }
        })
        .catch(err => {
          console.log(err);
        });
    },
    // 起点
    datanewmap() {
      var _self = this;
      _self.first = 10;
      _self.newdata = [];
      _self.data.map(item => {
        console.log(item);
        if (_self.city == item.name) {
          _self.newdata.push({
            name: item.name,
            value: item.value,
            data: _self.names.replace(/\"/g, "")
          });
        }
      });
      console.log(_self.newdata);
      let arr = [];
      _self.data.map(item => {
        console.log(111);
        if (_self.citydata == item.name) {
          arr.push({
            name: item.name,
            value: item.value,
            data: _self.namesdata.replace(/\"/g, "")
          });
        }
        console.log(arr);
      });
      _self.newdata = _self.newdata.concat(arr);
      console.log(_self.newdata);

      _self.newdatafirst = JSON.parse(JSON.stringify(_self.newdata));
      if (_self.newdataend.length > 0) {
        _self.startSt = 14;
      } else if (_self.newdataend.length > 1) {
        _self.startSt = 23;
      } else {
        _self.startSt = 2;
      }
      _self.$refs.initEcharts.initEcharts();
    },
    // 终点
    datanewsmap() {
      console.log(this.newdata);
      var _self = this;
      _self.startSt = 10;

      _self.newdata = [];
      console.log(111);
      _self.data.map(item => {
        console.log(item);
        if (_self.city == item.name) {
          _self.newdata.push({
            name: item.name,
            value: item.value,
            data: _self.names.replace(/\"/g, "")
          });
        }
      });
      let arr = [];
      _self.data.map(item => {
        console.log(111);
        if (_self.citydata == item.name) {
          arr.push({
            name: item.name,
            value: item.value,
            data: _self.namesdata.replace(/\"/g, "")
          });
        }
        console.log(arr);
      });
      _self.newdata = _self.newdata.concat(arr);
      console.log(_self.newdata);
      _self.newdataend = JSON.parse(JSON.stringify(_self.newdata));

      _self.$refs.initEcharts.initEcharts();
    },
    // 公有云列表
    getcloud() {
      const data = {
        token: this.$store.state.token
      };
      this.$http
        .post("/price/get_cloud", data)
        .then(res => {
          if (res.status == 200) {
            if (res.data.status == 0) {
              this.optioncloud = res.data.data.items;
            }
          }
        })
        .catch(err => {
          console.log(err);
        });
    },
    // 带宽列表
    getbandwidth() {
      const data = {
        token: this.$store.state.token,
        search_start_pop: this.popid,
        search_end_pop: this.popDataid,
        search_start_bandwidth: this.startBandwidth,
        search_end_bandwidth: this.endBandwidth
      };
      this.$http
        .post("/price/get_bandwidth", data)
        .then(res => {
          if (res.status == 200) {
            if (res.data.status == 0) {
              console.log(res.data.data.items);
              this.optiontime = res.data.data.items;
            }
          }
        })
        .catch(err => {
          console.log(err);
        });
    },
    // 汇率
    getrate() {
      const data = {
        token: this.$store.state.token
      };
      this.$http.post("/price/get_rate", data).then(res => {
        if (res.status == 200) {
          if (res.data.status == 0) {
            console.log(res.data.data.rate);
            this.rate = res.data.data.rate;
          }
        }
      });
    },
    tapbasis() {
      this.tapflag = true;
      this.tapflags = false;
    },
    taplines() {
      this.tapflag = false;
      this.tapflags = true;
      this.pack = true;
      this.packForm.packnum = "";
      this.overtime = this.$t("checkvalid.loss");
      this.loss = this.$t("checkvalid.loss");
      console.log(this.tapflags);
    }
  }
};
</script>
<style lang="scss">
.priceContent {
  width: 100%;
  background: #f4f4f4;
  .backimg {
    position: relative;
    overflow: hidden;
    .betweencenter {
      width: 1200px;
      margin: 0 auto;
      .real {
        position: absolute;
        top: 150px;
        z-index: 1000;
        text-align: left;
        .tis {
          // width: 420px;
          letter-spacing: 0px;
          line-height: 16px;
          font-size: 48px;
        }
        .tixt {
          width: 390px;
          margin-top: 36px;
          line-height: 24px;
          letter-spacing: 1px;
        }
      }
    }
  }
  .priceContainer {
    width: 1200px;
    margin: 0 auto;
    display: flex;
    justify-content: space-between;
    margin-top: 30px;
    padding-bottom: 60px;
    .creates.creatclo {
      width: 510px !important;
    }
    .creates {
      width: 480px;
      text-align: center;
      background: #fff;
      margin-right: 20px;
      .titles {
        padding-top: 30px;
        height: 60px;
        line-height: 60px;
        font-size: 30px;
        font-weight: 400;
        margin-bottom: 30px;
      }
      .imgs {
        width: 100%;
        padding-bottom: 20px;
        img {
          width: 26px;
          height: 40px;
          vertical-align: middle;
        }
        .colorsred {
          color: red !important;
          font-size: 26px !important;
        }
        .basisfont {
          color: #666;
          font-weight: 400;
        }
        .btns {
          margin: 26px 0;
          display: flex;
          justify-content: center;
          .headerTitle {
            display: flex;
            justify-content: space-around;
            align-items: center;
            .el-radio-button {
              width: 195px;
              .el-radio-button__inner {
                width: 100%;
                border: 1px solid #1d5a33;
                padding: 17.5px 20px !important;
              }
            }
            .el-radio-group {
              // :focus {
              //   outline-width: none;
              // }
            }

            .el-radio-button__orig-radio:checked + .el-radio-button__inner {
              background-color: #1d5a33;
              color: #fff;
              box-shadow: none;
            }
            .el-radio-button__inner:hover {
              color: #1d5a33;
            }
            .el-radio-button:focus:not(.is-focus):not(:active):not(.is-disabled) {
              box-shadow: none;
            }
            .el-radio-button:first-child .el-radio-button__inner {
              border-radius: 10px 0 0 10px;
            }
            .el-radio-button:last-child .el-radio-button__inner {
              border-radius: 0 10px 10px 0;
            }
          }
          .elbutton {
            width: 262px;
            height: 50px;
            line-height: 50px;
            color: #fff;
            background-color: #1d5a33;
            border-radius: 10px;
            cursor: pointer;
          }
        }
        .heads {
          width: 100%;
          height: 30px;
          text-align: left;
          display: flex;
          justify-content: left;
          align-items: center;
          margin-left: 20px;
          cursor: pointer;
          font-size: 18px;
          color: #333333;
          .one {
            // width: 15%;
            text-align: center;
            height: 30px;
            font-size: 18px;
          }
          .two {
            // width: 15%;
            text-align: center;
            height: 30px;
            font-size: 18px;
          }
          .active {
            // width: 15%;
            height: 28px;
            text-align: center;
            border-bottom: 2px solid #1d5a33;
            font-size: 18px;
          }
          .actives {
            // width: 15%;
            height: 28px;
            text-align: center;
            border-bottom: 2px solid #1d5a33;
            font-size: 18px;
          }
        }
        .basis {
          // padding: 30px 20px 10px 20px;
          width: 90%;
          margin-left: 20px;
          text-align: left;
          margin-top: 30px;
          .dis {
            display: flex;
            justify-content: left;
            align-items: center;
            margin-bottom: 20px;
            .el-radio-button {
              width: 76px;
              margin-right: 10px;
              .el-radio-button__inner {
                width: 100%;
                padding: 6px 0px !important;
                border: 1px solid #1d5a33;
                border-radius: 10px;
              }
            }
            .el-radio-button__orig-radio:checked + .el-radio-button__inner {
              background-color: #1d5a33;
              color: #fff;
              box-shadow: none;
            }
            .el-radio-button__inner:hover {
              color: #1d5a33;
            }
            .el-radio-button:focus:not(.is-focus):not(:active):not(.is-disabled) {
              box-shadow: none;
            }
            .wid {
              width: 80px;
              display: inline-block;
              text-align: left;
            }
            .inline {
              display: inline-block;
              width: 215px;
              height: 36px;
              line-height: 36px;
              border: 1px dashed #1d5a33;
              border-radius: 8px;
              text-align: center;
              font-weight: 700;
              color: #339933;
            }
          }
          .inputsty {
            .el-input__inner {
              border-radius: 10px;
              width: 266px;
            }
          }
          .left {
            .el-form-item__label {
              text-align: left;
            }
          }
          .el-select {
            width: 200px;
            .el-input {
              width: 200px;
            }
            .el-input__inner {
              width: 200px;
            }
          }
          .el-select {
            .el-input__inner {
              border: solid 1px #1d5a33;
              border-radius: 10px;
            }
          }
          .el-input {
            width: 160px;
          }
          .el-input__inner {
            width: 160px;
          }
          .el-input-number__increase {
            right: -29px;
          }
        }
        .hes {
          margin-bottom: 86px;
        }
        // .low {
        //   margin-bottom: 51.2px;
        // }
        //  配置详情
        li {
          box-sizing: border-box;
          padding: 16px 35px;
          border-bottom: 1px solid #999;
        }
        .tr {
          text-align: left;
          color: #333;
          font-weight: 700;
          font-size: 18px;
          span {
            font-weight: 700;
            font-size: 16px;
          }
        }
        .pc {
          line-height: 1.6;
          box-sizing: border-box;
          font-size: 15px;
          color: #666;
          display: flex;
          justify-content: center;
          span:nth-child(1) {
            font-size: 15px;
            margin-right: 20px;
            display: inline-block;
            width: 130px;
            text-align: right;
          }
          span:nth-child(2) {
            width: 180px;
            display: inline-block;
            text-align: left;
            font-size: 15px;
            margin-right: 20px;
          }
        }
        .pcs {
          line-height: 1.6;
          box-sizing: border-box;
          font-size: 15px;
          color: #666;
          display: flex;
          justify-content: right;
          span:nth-child(1) {
            float: right;
            font-size: 15px;
            margin-right: 20px;
            display: inline-block;
            width: auto;
            text-align: right;
          }
          span:nth-child(2) {
            float: left;
            text-align: left;
            font-size: 15px;
            margin-right: 20px;
          }
        }
      }
      .details {
        font-size: 28px;
        height: 50px;
        line-height: 50px;
        border-bottom: 1px solid #999999;
      }
    }
    .maps {
      width: 700px;
      background: #fff;
      position: relative;
    }
  }
  // 弹窗配置
  .dialog {
    display: flex;
    justify-content: space-around;
    align-items: center;
    .tl {
      width: 184px;
      text-align: center;
      border: 1px solid #1d5a33;
      border-radius: 10px;
      cursor: pointer;
      padding-bottom: 36px;
      .start {
        height: 110px;
        margin-top: 73px;
        margin-bottom: 50px;
      }
      .end {
        height: 110px;
        margin-top: 64px;
        margin-bottom: 59px;
      }
      img {
        vertical-align: middle;
      }
      div {
        font-size: 22px;
        color: #1d5a33;
      }
    }
    .tl:hover {
      box-shadow: 1px 1px #ccc;
    }
    .tls {
      width: 184px;
      text-align: center;
      border: 1px solid #1d5a33;
      border-radius: 10px;
      cursor: pointer;
      padding-bottom: 36px;
      .start {
        height: 110px;
        margin-top: 73px;
        margin-bottom: 50px;
      }
      .end {
        height: 110px;
        margin-top: 64px;
        margin-bottom: 59px;
      }
      img {
        vertical-align: middle;
      }
      div {
        font-size: 22px;
        color: #1d5a33;
      }
    }
  }
  // 弹窗-提交售后
  .dialogs {
    display: flex;
    justify-content: center;
    flex-direction: column;
    align-items: center;
    padding: 0 60px;
    .text {
      width: 380px;
      margin: 20px 0;
      text-align: center;
    }
    .tit {
      width: 380px;
      text-align: left;
    }
    li {
      font-size: 14px;
      color: #666;
      line-height: 27px;
    }
  }
  .el-dialog__header {
    margin: 0 20px;
    padding: 25px 30px 20px 30px;
    border-bottom: 1px solid #999;
    .el-dialog__title {
      color: #1d5a33;
    }
  }
  .el-select {
    .el-input__inner {
      border: solid 1px #1d5a33;
    }
  }
  .el-select .el-input.is-focus .el-input__inner {
    border-color: #1d5a33;
  }
  .el-cascader-panel {
    border-radius: 0;
    border: 0;
  }
  .titlehead {
    width: 28%;
    height: 30px;
    line-height: 30px;
    text-align: center;
    color: #1d5a33;
    border: solid 1px #1d5a33;
    border-bottom: solid 2px #999;
  }
  .el-input__inner {
    border: solid 1px #1d5a33;
  }
  .radiogroup.el-radio-group {
    padding-top: 13px;
    line-height: 40px;
    height: 40px;
    box-sizing: border-box;
  }
  .el-radio-button__inner {
    border-color: #1d5a33 !important;
  }
  .el-radio__input.is-checked + .el-radio__label {
    color: #1d5a33;
  }
  .el-radio__input.is-checked .el-radio__inner {
    border-color: #1d5a33;
    background: #1d5a33;
  }
  .timebuy {
    .el-radio-button__inner {
      padding: 12px 8px;
    }
    .el-radio-button__inner:hover {
      color: #1d5a33;
    }
    .el-radio-button__orig-radio:checked + .el-radio-button__inner {
      background-color: #1d5a33;
      border-color: #1d5a33;
      box-shadow: -1px 0 0 0 #1d5a33;
      color: #fff;
    }
  }
  .silder,
  .el-slider__runway {
    width: 312px;
    margin-left: 4px;
    .el-slider__button {
      width: 12px;
      height: 12px;
      border-color: #1d5a33;
    }
    .el-slider__bar {
      background-color: #1d5a33;
    }
    .el-slider__button-wrapper {
      // left: 9px !important;
    }
  }
}
</style>
